// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KdKUoAwY4v0Y64q8Ue9X,.AilYEk0qx3AUwKPi3iAs{padding-top:8px;padding-bottom:8px;display:flex}.AilYEk0qx3AUwKPi3iAs{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KdKUoAwY4v0Y64q8Ue9X`,
	"recordAudio": `AilYEk0qx3AUwKPi3iAs`
};
export default ___CSS_LOADER_EXPORT___;
